import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'
import CompanyDetails from './CompanyDetails'
import ManualInfo from './ManualInfo'

const CheckBusinessShareholders = ({ shareholdersCheck, name, currentCountry, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  const hasChecks = Array.isArray(shareholdersCheck) && shareholdersCheck?.length > 0
  const checkLength = shareholdersCheck?.length || 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{name}</Typography>

        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      {!Array.isArray(shareholdersCheck) && shareholdersCheck?.informação && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle1">{t('common:information')}</Typography>
          <Typography variant="subtitle3">{shareholdersCheck.informação ?? '---'}</Typography>
        </Paper>
      )}

      {hasChecks &&
        shareholdersCheck?.map((element, index) => {
          return (
            <Paper key={index} variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              {/* COMPANY DETAILS */}
              <CompanyDetails currentCountry={currentCountry} kyb={element} entity={'BUSINESS'} />

              {/* MANUAL DATA */}
              <ManualInfo kyb={element} />
            </Paper>
          )
        })}
    </>
  )
}

export default CheckBusinessShareholders
